<template>
  <el-form-item label="Pricing">
    <el-switch
      v-model="rateInCPM"
      active-text="CPM"
      :inactive-text="cpvText"
      @update:modelValue="update"
    />
  </el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref, watch, computed } from 'vue'

export default defineComponent({
  name: 'PricingSelector',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    cpc: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const rateInCPM = ref(props.modelValue)

    watch(rateInCPM, (newValue, _oldValue) => {
      if (newValue === true) {
        context.emit('remove', props.modelValue)
      }
    })

    const cpvText = computed(() => {
      return props.cpc ? 'CPC' : 'CPV'
    })

    const update = (newValue: boolean) => {
      context.emit('update:modelValue', newValue)
    }

    return { update, rateInCPM, cpvText }
  }
})
</script>
